import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CModalRecordAudioComponent } from './c-modal-record-audio.component';
import { IonicModule } from '@ionic/angular';
import { TimeFormatPipe } from 'src/app/pipes/time-format/time-format.pipe';



@NgModule({
declarations: [CModalRecordAudioComponent],
imports: [
  CommonModule,
  IonicModule,
  TimeFormatPipe
],
exports: [CModalRecordAudioComponent]
})
export class CModalAudioRecordModule { }
